var _excluded = ["children", "showIcon"];
var _templateObject;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
import React from "react";
import styled from "styled-components";
import { PhotoLibrarySystemIcon } from "@nib/icons";
import Copy from "./Copy";
import { Column, Columns } from "@nib/layout";
var ZeroFontSizeColumn = styled(Column)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: 0;\n\n  svg {\n    position: relative;\n    top: 2.5px;\n  }\n"])));
export var ImageCaption = function ImageCaption(_ref) {
  var children = _ref.children,
    _ref$showIcon = _ref.showIcon,
    showIcon = _ref$showIcon === void 0 ? false : _ref$showIcon,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  if (!showIcon) {
    return /*#__PURE__*/React.createElement(Copy, _extends({
      size: "small",
      color: "darker"
    }, otherProps, {
      "data-mesh-component": "IMAGE-CAPTION"
    }), children);
  }
  return /*#__PURE__*/React.createElement(Columns, _extends({
    space: 2
  }, otherProps, {
    "data-mesh-component": "IMAGE-CAPTION"
  }), /*#__PURE__*/React.createElement(ZeroFontSizeColumn, {
    width: "content"
  }, /*#__PURE__*/React.createElement(PhotoLibrarySystemIcon, {
    size: "xs",
    fill: "darker"
  })), /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Copy, {
    size: "small",
    color: "darker",
    component: "div",
    measure: false
  }, children)));
};
ImageCaption.displayName = "ImageCaption";